module.exports = __webpack_public_path__ + "assets/img/withdraw.857d642d.png";